import { useMemo } from "react";
import { useOutletContext } from "react-router-dom";
import { useClientAuth } from "../auth/ClientAuthProvider";
import { useClientPortalPaths } from "./useClientPortalBase";
import { casamapaAdminPortalPath } from "../constants/casamapaAdminPortalPaths";

export function useCasaMapaAdminPortal() {
  const paths = useClientPortalPaths();
  const { clientUser } = useClientAuth();
  const { activeViewId } = useOutletContext() || {};

  return useMemo(() => {
    const viewBase = activeViewId ? paths.view(activeViewId) : null;
    const displayName =
      clientUser?.displayName ||
      clientUser?.firstName ||
      clientUser?.email ||
      "Admin";

    return {
      clientViewId: activeViewId,
      resolvedViewId: activeViewId,
      viewBase,
      portalLabel: "CasaMapa",
      dashboardPath: paths.dashboard,
      path: (segment = "") => casamapaAdminPortalPath(segment),
      displayName,
      firstName: String(displayName).split(" ")[0],
    };
  }, [activeViewId, clientUser, paths]);
}
